import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadedFilePreviewComponent } from './components/file-upload/uploaded-file-preview/uploaded-file-preview.component';
import { MaterialComponentsModule } from '../material/material-components.module';
import { ProfileViewerComponent } from './components/profile-viewer/profile-viewer.component';
import { HoursAndMinutesPipe } from './pipes/hours-and-minutes.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { NameInitialsPipe } from './pipes/name-initials.pipe';
import { ScrollTrackerDirective } from './directives/scroll-tracker.directive';
import { ContentEditableDirective } from './directives/content-editable.directive';
import { RemoveHtmlTagsPipe } from './pipes/remove-html-tags.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { CommonLoaderComponent } from './components/common-loader/common-loader.component';
import { TableDataLoaderComponent } from './components/table-data-loader/table-data-loader.component';
import { ListLoaderComponent } from './components/list-loader/list-loader.component';
import { QuillEditorComponent } from './components/quill-editor/quill-editor.component';
import { ImageEditorComponent } from './components/image-editor/image-editor.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { OrdinalDatePipe } from './pipes/date-ordinal.pipe';
import { FileListViewerComponent } from './components/file-list-viewer/file-list-viewer.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VideoViewerComponent } from './components/video-viewer/video-viewer.component';
import { FileDeleteConfirmComponent } from './components/file-delete-confirm/file-delete-confirm.component';
import { TargetIdDirective } from './directives/target-id.directive';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decimal-number.directive';
import { PhonePipe } from './pipes/phone.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { StylePaginatorDirective } from './directives/style-paginator.directive';
import { BottomConfirmationMessageComponent } from './components/bottom-confirmation-message/bottom-confirmation-message.component';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NGX_MAT_DATE_FORMATS,
} from '@angular-material-components/datetime-picker';

import { SwiperModule } from 'swiper/angular';

import { SearchDebounceDirective } from './directives/search-debounce.directive';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { CustomDateTimePipe } from './pipes/date-custom.pipe';
import { PropertyExpenditureComponent } from './components/property-expenditure/property-expenditure.component';
import { PropertyExpenditureDetailsComponent } from './components/property-expenditure/property-expenditure-details/property-expenditure-details.component';
import { PropertyExpenditureSummaryComponent } from './components/property-expenditure/property-expenditure-summary/property-expenditure-summary.component';
import { PropertyExpenditureDetailItemsComponent } from './components/property-expenditure/property-expenditure-detail-items/property-expenditure-detail-items.component';
import { JobSnoozeComponent } from './components/job-snooze/job-snooze.component';
import { AssetsContainerComponent } from './components/assets-container/assets-container.component';
import { AssetsListComponent } from './components/assets-container/assets-list/assets-list.component';
import { AddAssetComponent } from './components/assets-container/add-asset/add-asset.component';
import { AssetDetailsComponent } from './components/assets-container/asset-details/asset-details.component';
import { AssetDetailsOverviewComponent } from './components/assets-container/asset-details/asset-details-overview/asset-details-overview.component';
import { EditAssetComponent } from './components/assets-container/edit-asset/edit-asset.component';
import { DeleteAasetComponent } from './components/assets-container/delete-aaset/delete-aaset.component';
import { JobsForAssetComponent } from './components/assets-container/asset-details/jobs-for-asset/jobs-for-asset.component';
import { SentToTenantAssetComponent } from './components/assets-container/sent-to-tenant-asset/sent-to-tenant-asset.component';
import {AutosizeModule} from 'ngx-autosize';
import { TextToSpeechComponent } from './components/text-to-speech/text-to-speech.component';
import { CustomePopoverComponent } from './components/popover/app-popover.component';
import { PopoverModule } from 'ngx-smart-popover';
import { filterPipe } from './pipes/filter.pipe';
import { AlexComponent } from './components/alex/alex.component';
import { PhoneNumberOnlyDirective } from './directives/phone-number-only.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
  declarations: [
    FileUploadComponent,
    DragAndDropDirective,
    UploadedFilePreviewComponent,
    ProfileViewerComponent,
    HoursAndMinutesPipe,
    TimeAgoPipe,
    StarRatingComponent,
    NameInitialsPipe,
    ScrollTrackerDirective,
    ContentEditableDirective,
    RemoveHtmlTagsPipe,
    DateFormatPipe,
    CommonLoaderComponent,
    TableDataLoaderComponent,
    ListLoaderComponent,
    QuillEditorComponent,
    ImageEditorComponent,
    ImageViewerComponent,
    ImageGalleryComponent,
    OrdinalDatePipe,
    FileListViewerComponent,
    PdfViewerComponent,
    VideoViewerComponent,
    FileDeleteConfirmComponent,
    TargetIdDirective,
    TwoDigitDecimaNumberDirective,
    PhonePipe,
    StylePaginatorDirective,
    BottomConfirmationMessageComponent,
    StylePaginatorDirective,
    SearchDebounceDirective,
    CustomDateTimePipe,
    PropertyExpenditureComponent,
    PropertyExpenditureDetailsComponent,
    PropertyExpenditureSummaryComponent,
    PropertyExpenditureDetailItemsComponent,
    JobSnoozeComponent,
    AssetsContainerComponent,
    AssetsListComponent,
    AddAssetComponent,
    AssetDetailsComponent,
    AssetDetailsOverviewComponent,
    EditAssetComponent,
    DeleteAasetComponent,
    JobsForAssetComponent,
    SentToTenantAssetComponent,
    TextToSpeechComponent,
    CustomePopoverComponent,
    filterPipe,
    PhoneNumberOnlyDirective,
    AlexComponent,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialComponentsModule,
    PdfViewerModule,
    ReactiveFormsModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    SwiperModule,
    AutosizeModule,
    PopoverModule
  ],
  exports: [
    StylePaginatorDirective,
    FileUploadComponent,
    ProfileViewerComponent,
    HoursAndMinutesPipe,
    TimeAgoPipe,
    StarRatingComponent,
    NameInitialsPipe,
    ScrollTrackerDirective,
    ContentEditableDirective,
    RemoveHtmlTagsPipe,
    DateFormatPipe,
    CommonLoaderComponent,
    TableDataLoaderComponent,
    ListLoaderComponent,
    QuillEditorComponent,
    ImageEditorComponent,
    ImageViewerComponent,
    ImageGalleryComponent,
    OrdinalDatePipe,
    FileListViewerComponent,
    PdfViewerComponent,
    VideoViewerComponent,
    TargetIdDirective,
    PhonePipe,
    TwoDigitDecimaNumberDirective,
    MatAutocompleteModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    SearchDebounceDirective,
    CustomDateTimePipe,
    PropertyExpenditureComponent,
    PropertyExpenditureSummaryComponent,
    PropertyExpenditureDetailsComponent,
    PropertyExpenditureDetailItemsComponent,
    JobSnoozeComponent,
    AssetsContainerComponent,
    AssetsListComponent,
    AddAssetComponent,
    AssetDetailsComponent,
    AssetDetailsOverviewComponent,
    EditAssetComponent,
    DeleteAasetComponent,
    JobsForAssetComponent,
    AutosizeModule,
    TextToSpeechComponent,
    CustomePopoverComponent,
    filterPipe,
    PhoneNumberOnlyDirective,
    AlexComponent,
    SafeHtmlPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
